import * as React from 'react';

import {ReactErrorBoundary} from 'iron/common/components/react-error-boundary';

import {lazy} from './lazy-loader';

export const lazyWithErrorBoundary = <T extends React.ComponentType<any>>(
  dynamicImport: () => Promise<{default: T}>,
  key?: React.Key,
) => <ReactErrorBoundary errorType='lazy load error boundary'>{lazy(dynamicImport, key)}</ReactErrorBoundary>;
